import { useEffect, useState } from "react";
import {
    Row,
    Col,
    Card,
    Table,
    notification,
    Pagination,
    Input
} from "antd";
import axios from "axios";
import { baseUrl } from "../../config";
import { skeletonData } from '../../components/skeletons/Report';
import moment from "moment";

const { Search } = Input;

// table code start
const columns = [
    {
        title: "#",
        dataIndex: "index",
        key: "index",
    },
    {
        title: "Email",
        dataIndex: "email",
        key: "email",
    },
    {
        title: "Subscribe Date",
        dataIndex: "createdAt",
        key: "createdAt",
    },
];

function NewsletterList() {
    const [userList, setUserList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalUsers, setTotalUsers] = useState(0);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        getContactList();
    }, [searchTerm, currentPage, pageSize]); // Update data when page or page size changes

    async function getContactList() {
        try {
            setLoading(true);

            const params = {
                page: currentPage,
                items: pageSize,
            };

            // Check if search is not null or empty, then add it to params
            if (searchTerm && searchTerm.trim() !== '') {
                params.filter = 'sentTo';
                params.equal = searchTerm;
                // params.fields = 'name,email'; // Specify searchable fields
            }

            const response = await axios.get(`${baseUrl}/api/user/newsletters`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`, // Include access token in headers
                },
                params
            });
            if (response.data.success) {
                setUserList(response.data.result);
                setTotalUsers(response.data.pagination.count);
            } else {
                setUserList([])
            }
        } catch (error) {
            notification.info({
                message: 'Info',
                description: error.response?.data?.message,
                placement: 'topRight',
            });
        } finally {
            setLoading(false);
        }
    }

    const handlePageChange = (page, pageSize) => {
        setCurrentPage(page);
        setPageSize(pageSize);
    };

    const handleSearch = (value) => {
        if (value.length >= 3 || value.length === 0) {
            setSearchTerm(value);
            setCurrentPage(1);
        }
    };

    return (
        <>
            <div className="tabled">
                <Row gutter={[24, 0]}>
                    <Col xs="24" xl={24}>
                        <Card
                            bordered={false}
                            className="criclebox tablespace mb-24"
                            title="Newsletters"
                            extra={<Search placeholder="Search by email" onSearch={handleSearch} allowClear />}
                        >
                            <div className="table-responsive">
                                <Table
                                    columns={columns}
                                    dataSource={loading ? skeletonData : userList.map((user, index) => ({
                                        index: (currentPage - 1) * pageSize + index + 1,
                                        email: (
                                            <p>{user.sentTo}</p>
                                        ),
                                        createdAt: (
                                            <p>{moment(user.createdAt).format("MMMM DD, YYYY hh:mm A")}</p>
                                        ),
                                    }))}
                                    pagination={false} // Disable default pagination inside the table
                                />
                            </div>
                            {/* Keep pagination outside the scrollable div */}
                            <div className="pagination-container">
                                <Pagination
                                    current={currentPage}
                                    pageSize={pageSize}
                                    total={totalUsers}
                                    onChange={handlePageChange}
                                />
                            </div>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    );
}

export default NewsletterList;
